import './assignmentcalculator.controller.js';
import 'Sass/views/assignment-calculator.scss';